(function () {
  function initRedoDrawer() {
    var drawerCloseCount = 0;

    function setCookie(name, value, minutes) {
      var expires = new Date(Date.now() + minutes * 60 * 1000).toUTCString();
      document.cookie =
        name + '=' + encodeURIComponent(value) + '; expires=' + expires + '; path=/; SameSite=Lax';
    }

    function getCookie(name) {
      return document.cookie.split('; ').reduce(function (result, item) {
        var parts = item.split('=');
        return parts[0] === name ? decodeURIComponent(parts[1] || '') : result;
      }, '');
    }

    if (!document.getElementById('osh-redo-drawer-style')) {
      var style = document.createElement('style');
      style.id = 'osh-redo-drawer-style';
      style.innerHTML = `
        #osh-redo-side-tab{
          position:fixed!important;
          left:0!important;
          top:58%!important;
          transform:translate(0,-50%)!important;
          z-index:2147483647!important;
          background:#fff!important;
          color:#000!important;
          border:1px solid #000!important;
          border-left:0!important;
          padding:12px 8px!important;
          font:700 15px/1 Arial,sans-serif!important;
          writing-mode:vertical-rl!important;
          cursor:pointer!important;
          box-shadow:0 2px 8px rgba(0,0,0,.25)!important;
        }

        #osh-redo-side-tab:hover{
          background:#000!important;
          color:#fff!important;
        }

        #osh-redo-drawer{
          position:fixed!important;
          left:0!important;
          top:50%!important;
          width:390px!important;
          max-width:92vw!important;
          max-height:92vh!important;
          overflow:auto!important;
          background:#fff!important;
          border:1px solid #ddd!important;
          box-shadow:0 6px 28px rgba(0,0,0,.28)!important;
          padding:24px!important;
          box-sizing:border-box!important;
          z-index:2147483646!important;
          transform:translate(-110%,-50%)!important;
          transition:transform .35s ease!important;
          visibility:visible!important;
        }

        #osh-redo-drawer.is-open{
          transform:translate(0,-50%)!important;
        }

        #osh-redo-close{
          position:absolute!important;
          right:8px!important;
          top:4px!important;
          border:0!important;
          background:none!important;
          color:#000!important;
          font-size:30px!important;
          line-height:1!important;
          cursor:pointer!important;
          z-index:2!important;
        }

        #osh-redo-close:hover{
          opacity:.7!important;
        }

        @media(max-width:768px){
          #osh-redo-side-tab{
            font-size:14px!important;
            padding:10px 7px!important;
          }

          #osh-redo-drawer{
            width:92vw!important;
            padding:20px!important;
          }
        }
      `;
      document.head.appendChild(style);
    }

    var drawer = document.getElementById('osh-redo-drawer');

    if (!drawer) {
      console.error('osh-redo-drawer not found');
      return;
    }

    drawer.style.visibility = 'visible';

    var close = document.getElementById('osh-redo-close');

    if (!close) {
      close = document.createElement('button');
      close.id = 'osh-redo-close';
      close.type = 'button';
      close.setAttribute('aria-label', 'Close');
      close.textContent = '×';
      drawer.prepend(close);
    }

    var tab = document.getElementById('osh-redo-side-tab');

    if (!tab) {
      tab = document.createElement('button');
      tab.id = 'osh-redo-side-tab';
      tab.type = 'button';
      tab.textContent = 'Get 10% OFF';
      document.body.appendChild(tab);
    }

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      tab.style.display = 'none';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');

      drawerCloseCount++;

      if (drawerCloseCount >= 2) {
        setCookie('osh_redo_tab_closed', '1', 30);
        tab.style.display = 'none';
        return;
      }

      if (getCookie('osh_redo_tab_closed') !== '1') {
        tab.style.display = 'block';
      }
    }

    if (getCookie('osh_redo_tab_closed') === '1') {
      tab.style.display = 'none';
    } else {
      tab.style.display = 'block';
    }

    tab.onclick = function () {
      openDrawer();
    };

    close.onclick = function () {
      closeDrawer();
    };

    var form = drawer.querySelector('form');

    if (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();

        var btn = form.querySelector('button[type="submit"]');
        var originalText = btn ? btn.textContent : '';

        if (btn) {
          btn.disabled = true;
          btn.textContent = 'Signing up...';
        }

        fetch(form.action, {
          method: 'POST',
          body: new FormData(form),
          headers: { 'Accept': 'application/json' },
          credentials: 'omit'
        })
          .then(function (res) {
            return res.json().then(function (data) {
              if (!res.ok) {
                throw new Error(data.message || 'Signup failed.');
              }
              return data;
            }).catch(function (err) {
              if (err instanceof SyntaxError) {
                throw new Error('Signup failed. Please try again.');
              }
              throw err;
            });
          })
          .then(function (data) {
            console.log('Signup response:', data);

            if (
              data.success === true ||
              data.status === 'success' ||
              data.status ||
              data.message
            ) {
              var message = data.message || 'Check your email for your 10% off coupon code. If you do not see it soon, check your Promotions tab or spam folder.';

              form.innerHTML =
                '<h3 style="text-align:center;margin:0 0 10px;font-size:28px;">Thanks for signing up!</h3>' +
                '<p style="text-align:center;margin:0;font-size:16px;">' +
                message.replace(/^Thanks for signing up!\s*/i, '') +
                '</p>';

              return;
            }

            throw new Error(data.message || 'Signup failed.');
          })
          .catch(function (err) {
            console.error(err);
            alert(err.message || 'Signup failed.');

            if (btn) {
              btn.disabled = false;
              btn.textContent = originalText;
            }
          });
      });
    }

    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initRedoDrawer);
  } else {
    initRedoDrawer();
  }
})();